import { Link, useLocation, useNavigate } from 'react-router-dom'
import homePng from '../../images/header/home.png'
import { useContext, useEffect, useState } from 'react'
import { getBanerimgList, BASE_URL } from '../../api/api'
import useMediaQuery from '../../hooks/useMediaQuery'
import search from '../../images/header/search.png'
import moment from 'moment'
import 'moment/locale/zh-cn'
import HeaderContext from '../../context/headerContext'
import { Input } from 'antd'
import NavLink from '../navLink'

const Header = () => {
  const [banner, setBanner] = useState({
    image: '',
    image2: ''
  })
  const [value, setValue] = useState('')
  const { navList } = useContext(HeaderContext)
  let { pathname } = useLocation()
  pathname = pathname.replace('/', '') || ''

  const isMobile = useMediaQuery()

  useEffect(() => {
    getBanerimgList().then(res => {
      const [img1, img2] = res?.data || []
      const { image = '' } = img1 || {}
      const { image: image2 = '' } = img2 || {}
      setBanner({ image, image2 })
    })
  }, [])

  moment.locale('zh-cn')
  // 获取当前时间
  const currentTime = moment()

  // 格式化为指定格式
  const formattedTime = currentTime.format('YYYY年M月D日 dddd')
  const navigate = useNavigate()

  const onSearch = () => {
    navigate(`/hyjj?keyword=${value}`)
  }

  const onChange = e => {
    setValue(e.target.value)
  }

  if (isMobile) {
    if (window.location.pathname === '/') {
      return (
        <div>
          <div className="relative">
            <img src={`${BASE_URL}${banner?.image2 || ''}`} alt="" />
            <svg
              fill="white"
              viewBox="0 0 24 24"
              stroke="currentColor"
              width="24"
              height="24"
              className=" absolute right-2 top-2 "
              onClick={() => {
                navigate('/hyjj')
              }}
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 4a6 6 0 106 6 6 6 0 00-6-6zm0 12a6 6 0 100-12 6 6 0 000 12zm10 0l-4-4"
              />
            </svg>
          </div>
          <div className="px-5 py-2 flex hidden-scrollbar">
            <div className="flex items-center justify-between flex-wrap">
              {navList.map(({ id, name, diyname = '', outlink }) => (
                <NavLink
                  className="font-alhpr mr-5 whitespace-nowrap block w-[62px]"
                  key={id}
                  isOutLink={!!outlink}
                  to={outlink || `/${diyname ? `${diyname}/channel_id/${id}` : ''}`}
                >
                  {name}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <div className="bg-[#0189D5] p-5">
            <div className="w-full rounded-xl flex bg-white items-center px-[20px] py-2">
              <input
                onChange={e => onChange(e)}
                placeholder="请输入关键字"
                className="flex-1 mr-2"
              />
              <img onClick={onSearch} style={{ width: 20 }} src={search} alt="" />
            </div>
          </div>
          <div className="px-5 py-2 flex ">
            <div className="flex items-center justify-between flex-wrap">
              {navList.map(({ id, name, diyname = '', outlink }) => (
                <NavLink
                  className="font-alhpr mr-5 whitespace-nowrap block w-[62px]"
                  key={id}
                  isOutLink={!!outlink}
                  to={outlink || `/${diyname ? `${diyname}/channel_id/${id}` : ''}`}
                >
                  {name}
                </NavLink>
              ))}
            </div>
          </div>
          <img src={`${BASE_URL}${banner?.image2 || ''}`} alt="" />
        </div>
      )
    }
  }

  return (
    <div>
      <div
        // style={{ backgroundImage: `url('${BASE_URL}${banner?.image}')` }}
        className="mx-auto w-full bg-no-repeat relative"
      >
        <img
          className=""
          // style={{ height: 380 }}
          src={`${BASE_URL}${banner?.image || ''}`}
          alt=""
        />
        <div className="max-w-1200 mx-auto w-full absolute top-5 left-[50%] transform-translate-x-1/2">
          <div className="flex  text-white items-center font-alhpr">
            <div className="mr-12 rounded-xl flex bg-white items-center pl-2 pr-[20px]">
              <Input
                onChange={onChange}
                value={value}
                className="mr-2 border-none focus:shadow-none"
              />
              <img
                className=" cursor-pointer"
                onClick={onSearch}
                style={{ width: 20 }}
                src={search}
                alt=""
              />
            </div>
            <p className="mr-12 text-sm">{formattedTime}</p>
            <NavLink className="text-sm flex items-center" to="/">
              <img style={{ width: 19, height: 18 }} src={homePng} alt="" />
              <span className="ml-2">官方首页</span>
            </NavLink>
          </div>
        </div>
      </div>
      <div className="w-full font-alhpr shadow-md">
        <ul className="max-w-1200 mx-auto flex items-center justify-between relative">
          {/* <li className="w-[128px]"></li> */}
          {navList.map(({ name, diyname, id }, key) => (
            <li
              // className={`${
              //   !key
              //     ? 'w-[128px] h-[73px] bg-homeBg bg-cover text-[22px] absolute left-0 top-[-13px] text-center leading-[73px]'
              //     : 'text-xl py-3'
              // } ${diyname && diyname === pathname ? 'border-b-[5px] border-[#0189D5]' : ''}`}
              key={id}
              className={`text-xl py-3 ${
                diyname && diyname === pathname ? 'border-b-[5px] border-[#0189D5]' : ''
              }`}
            >
              {diyname ? (
                <NavLink
                  // className={`${!key && 'text-white'} text-[#333333]`}
                  className={` text-[#333333]`}
                  to={`/${diyname ? `${diyname}/channel_id/${id}` : ''}`}
                >
                  {name}
                </NavLink>
              ) : (
                <a
                  // className={`${!key && 'text-white'} text-[#333333]`}
                  className={` text-[#333333]`}
                  href={`/${window.location.search}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {name}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Header
